import {PageSlot} from "mfront";

export default function DefaultLayout() {
    return (
        <>
            Default Layout
            <div>
                <PageSlot/>
            </div>
        </>
    )
}